import React, { useMemo, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Login } from "./Components/Auth";
import { UploadContext } from "./Components/Context/UploadContext";
import UserDashboard from "./Components/Home";
import RTMAdminDashboard from "./Components/RTM Admin";
import TenantConfig from "./Components/RTM Admin/TenantConfig";
// import MainLayout from "./Layouts/MainLayout";
import RTMAdminLayout from "./Layouts/RTMAdminLayout";
import ProtectedRoute from "./Routing/ProtectedRoute";
import { RoutesService } from "./Services";
import { DASH_BOARD, LANDING_PAGE } from "./Services/routesService";
import Ecommerce from "./Components/Home/Ecommerce";
import StoreScoring from "./Components/Store Scoring/StoreScoring";
import PromotorSchedule from "./Components/Promotor Schedule";
import LandingPage from "./Components/LandingPage";
import userServices from "./UserServices/UserServices";

function App() {
	const [isUploading, setIsUploading] = useState(false);

	const { tenant } = useMemo(() => {
		const user = userServices.getCurrentUser();
		return {
			tenant: user?.tenant || "defaultTenant"
		};
	}, []);
	console.log("Tenant:", tenant);
	return (
		<main>
			<ToastContainer autoClose={3000} hideProgressBar={true} />
			<UploadContext.Provider value={{ isUploading, setIsUploading }}>
				<BrowserRouter>
					<Routes>
						{/* Public Routes */}
						<Route path={RoutesService.getLoginRoute()} element={<Login />} />
						{/* Protected Routes for general users */}
						<Route path="/ecommerce" Component={Ecommerce} />
						<Route path="/store-score" Component={StoreScoring} />
						<Route path="/promotor-schedule" Component={PromotorSchedule} />
						{/* <Route path="/landing-page" Component={UserDashboard} /> */}

						{/* {tenant === "BAT_STATES" && ( */}
						<Route
							// element={<MainLayout />}
							path={`${LANDING_PAGE}/:selectedRoute?`}
							Component={UserDashboard} // This will render the LandingPage component
						/>
						{/* // )} */}
						{/* 
						<Route
							element={<MainLayout />}
							path="/store-score"
							children={[
								<Route
									path={RoutesService.getRoleRoute("FIELD")}
									element={<ProtectedRoute component={StoreScoring} allowedRoles={["FIELD"]} />}
								/>,
								<Route
									path={RoutesService.getRoleRoute("SUPERVISOR")}
									element={<ProtectedRoute component={StoreScoring} allowedRoles={["SUPERVISOR"]} />}
								/>,
								<Route
									path={RoutesService.getRoleRoute("ADMIN")}
									element={<ProtectedRoute component={StoreScoring} allowedRoles={["ADMIN"]} />}
								/>
							]}
						/> */}
						{/* {tenant === "BAT_STATES" ? ( */}
						<Route
							path={`${DASH_BOARD}`}
							children={[
								<Route
									path={RoutesService.getRoleRoute("FIELD")}
									element={<ProtectedRoute component={LandingPage} allowedRoles={["FIELD"]} />}
								/>,
								<Route
									path={RoutesService.getRoleRoute("SUPERVISOR")}
									element={<ProtectedRoute component={LandingPage} allowedRoles={["SUPERVISOR"]} />}
								/>,
								<Route
									path={RoutesService.getRoleRoute("ADMIN")}
									element={<ProtectedRoute component={LandingPage} allowedRoles={["ADMIN"]} />}
								/>
							]}
						/>
						{/* // ) : ( */}
						{/* <Route
								path={`${DASH_BOARD}`}
								children={[
									<Route
										path={RoutesService.getRoleRoute("FIELD")}
										element={<ProtectedRoute component={UserDashboard} allowedRoles={["FIELD"]} />}
									/>,
									<Route
										path={RoutesService.getRoleRoute("SUPERVISOR")}
										element={
											<ProtectedRoute component={UserDashboard} allowedRoles={["SUPERVISOR"]} />
										}
									/>,
									<Route
										path={RoutesService.getRoleRoute("ADMIN")}
										element={<ProtectedRoute component={UserDashboard} allowedRoles={["ADMIN"]} />}
									/>
								]} */}
						{/* // /> */}
						{/* // )} */}

						{/* Protected Route for RTM Admin */}
						<Route
							element={<RTMAdminLayout />}
							path={`${DASH_BOARD}`}
							children={[
								<Route
									path={RoutesService.getRoleRoute("RTMADMIN")}
									element={
										<ProtectedRoute component={RTMAdminDashboard} allowedRoles={["RTMADMIN"]} />
									}
								/>,
								<Route
									path={RoutesService.getTenantRoute("RTMADMIN")}
									element={<ProtectedRoute component={TenantConfig} allowedRoles={["RTMADMIN"]} />}
								/>
							]}
						/>

						{/* Catch-all: redirect to 404 */}
						<Route path={RoutesService.getLoginRoute()} element={<Login />} />
						<Route
							path="*"
							element={
								<Navigate
									to={tenant === "BAT_STATES" ? `${LANDING_PAGE}` : RoutesService.getLoginRoute()}
								/>
							}
						/>
					</Routes>
				</BrowserRouter>
			</UploadContext.Provider>
		</main>
	);
}

export default App;
